import React from 'react';

function AddSubCategoryDefault({ fill = '#1D1C1D', width = 20, height = 20, style }) {
  return (
    <svg style={style} width={width} height={height} viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M11.875 13.3334H13.125V11.4584H15V10.2084H13.125V8.33337H11.875V10.2084H10V11.4584H11.875V13.3334ZM2.9375 16.6667C2.60417 16.6667 2.3125 16.5382 2.0625 16.2813C1.8125 16.0243 1.6875 15.7362 1.6875 15.4167V4.58337C1.6875 4.26393 1.8125 3.97574 2.0625 3.71879C2.3125 3.46185 2.60417 3.33337 2.9375 3.33337H8.77083L10.0208 4.58337H17.1042C17.4236 4.58337 17.7118 4.71185 17.9687 4.96879C18.2257 5.22574 18.3542 5.51393 18.3542 5.83337V15.4167C18.3542 15.7362 18.2257 16.0243 17.9687 16.2813C17.7118 16.5382 17.4236 16.6667 17.1042 16.6667H2.9375ZM2.9375 4.58337V15.4167H17.1042V5.83337H9.5L8.25 4.58337H2.9375Z" fill={fill} />
    </svg>

  );
}

export default AddSubCategoryDefault;
